import React, { useEffect, useState } from "react"
import { Schedule } from "source/giving/donate/form/types"
import { fetchStartDates } from "../queries"
import { useQuery } from "@tanstack/react-query"
import { dateStampStringToLocal } from "source/giving/donate/form/utils/frequency"
import { RecurringDonationStatus } from "../types"

interface NextOccurrenceProps {
  schedule: Schedule
  releaseHoldAt: string | null
  nextOccurrence: string | null
  status: RecurringDonationStatus
  initialStatus: RecurringDonationStatus
  onChangeNextOccurrence: (nextOccurrence: string | null) => void
}

export default function NextOccurrence({
  schedule,
  releaseHoldAt,
  nextOccurrence,
  status,
  initialStatus,
  onChangeNextOccurrence,
}: NextOccurrenceProps) {
  const [internalNextOccurrence, setInternalNextOccurrence] = useState<
    string | null
  >(nextOccurrence)

  useEffect(() => {
    setInternalNextOccurrence("")
  }, [schedule, releaseHoldAt])

  const {
    data: nextOccurrences,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["RecurringDonationStartDates", schedule, releaseHoldAt],
    queryFn: () => fetchStartDates(schedule, releaseHoldAt),
    enabled: nextOccurrence !== internalNextOccurrence,
  })

  useEffect(() => {
    const firstOccurrence = nextOccurrences?.[0] ?? null

    if (firstOccurrence && firstOccurrence !== internalNextOccurrence) {
      setInternalNextOccurrence(firstOccurrence)

      const isTransitioningFromHoldToActive =
        initialStatus !== "active" && status === "active"

      if (!isTransitioningFromHoldToActive) {
        onChangeNextOccurrence(firstOccurrence)
      }
    }
  }, [
    nextOccurrences,
    internalNextOccurrence,
    onChangeNextOccurrence,
    status,
    initialStatus,
  ])

  return (
    !isError &&
    internalNextOccurrence && (
      <span>
        {isFetching
          ? "..."
          : `${dateStampStringToLocal(internalNextOccurrence)}.`}
      </span>
    )
  )
}
